"use strict";
// @ts-ignore
try {
    self['workbox:core:7.2.0'] && _();
}
catch (e) { }
